import React from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MuiDateRangePickerDay from "@mui/lab/DateRangePickerDay";
import { styled } from "@mui/material/styles";
import DateRangePicker from "@mui/lab/DateRangePicker";
import StartEndDateIcon from "./../../../assets/svg/startEndDateIcon.svg";
import { FaCalendarAlt } from "react-icons/fa";
const DateRangePickerDay = styled(MuiDateRangePickerDay)(
  ({ theme, isHighlighting, isStartOfHighlighting, isEndOfHighlighting }) => ({
    ...(isHighlighting && {
      borderRadius: 0,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      "&:hover, &:focus": {
        backgroundColor: theme.palette.primary.dark,
      },
    }),
    ...(isStartOfHighlighting && {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%",
    }),
    ...(isEndOfHighlighting && {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%",
    }),
  })
);
const DateRangePickerComponent = () => {
  const [value, setValue] = React.useState([null, null]);
  const renderWeekPickerDay = (date, dateRangePickerDayProps) => {
    return <DateRangePickerDay {...dateRangePickerDayProps} />;
  };
  return (
    <div>
      <p className="header-input-heading">Search by Date</p>
      <div className="header-date-picker">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateRangePicker
            label="Advanced keyboard"
            value={value}
            onChange={(newValue) => setValue(newValue)}
            renderInput={(startProps, endProps) => (
              <React.Fragment>
                <input
                  ref={startProps.inputRef}
                  {...startProps.inputProps}
                  placeholder="Start Date"
                  className="header-date-picker-input"
                />
                <div className="header-date-picker-icon">
                  <img src={StartEndDateIcon} />
                </div>
                <input
                  ref={endProps.inputRef}
                  {...endProps.inputProps}
                  placeholder="End Date"
                  className="header-date-picker-input"
                />
              </React.Fragment>
            )}
          />
        </LocalizationProvider>
        <FaCalendarAlt color="#303030" />
      </div>
    </div>
  );
};
export default DateRangePickerComponent;
